import Stack from "components/Stack";
import Text from "components/Text";

import { IMemoSection } from "entities/Memo/sdk";

interface IMemoSectionHeader {
  section: IMemoSection;
}

const PrintableMemoSectionHeader = ({ section }: IMemoSectionHeader) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    data-testid="custom-header-section"
  >
    <Text variant="h2" data-testid="custom-header-title">
      {section.title}
    </Text>
  </Stack>
);

export default PrintableMemoSectionHeader;
